/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-16 10:11:45
 */
import { Form, Divider } from "antd";
// import { Histogram } from "./echarts/Histogram";
// import { LineChart } from "./echarts/LineChart";
// import { TrainRatio } from "./echarts/trainRatio";
import { BarChart } from "../components/barChart";
import {
  getCountryHospitalDataManage,
  getCountryUserDataManage,
  getCountryTrainDataManage,
  exportCountryHospitalDataManage,
  exportCountryUserDataManage,
  exportCountryTrainDataManage
} from "@root/common/service";
import { useEffect, useState } from "react";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
export interface EchartHostitalDataProps {
  provinceCode: string;
  provinceName: string;
  recipientHospitalCount: number;
  supportHospitalCount: number;
}
export interface EchartUserDataProps {
  learnUserCount: number;
  provinceCode: string;
  provinceName: string;
  userCount: number;
}
export interface EchartTrainDataProps {
  learnRatio: number;
  learnRatioText: string;
  learnUserCount: number;
  provinceCode: string;
  provinceName: string;
  userCount: number;
}

const China = () => {
  const [echartData, setEchartData] = useState<{
    hospitalData: EchartHostitalDataProps[];
    userData: EchartUserDataProps[];
    trainData: EchartTrainDataProps[];
  }>({
    hospitalData: [],
    userData: [],
    trainData: [],
  });

  const [hospitalChartData, setHospitalChartData] = useState<[]>([]);
  const [learningChartData, setLearningChartData] = useState<[]>([]);
  const [percentOfPassData, setPercentOfPassData] = useState<[]>([]);

  async function getOverAllOverViewData(subject?: number | undefined) {
    const { data: hospitalData } = await getCountryHospitalDataManage({ subjectId: subject });
    const { data: userData } = await getCountryUserDataManage({ subjectId: subject });
    const { data: trainData } = await getCountryTrainDataManage({ subjectId: subject });

    const initHospitalData: [] = hospitalData.map((item: EchartHostitalDataProps) => {
      return [
        item.provinceName,
        item.recipientHospitalCount,
        item.supportHospitalCount,
      ];
    })
    const initLearningData: [] = userData.map((item: EchartUserDataProps) => {
      return [
        item.provinceName,
        item.userCount,
        item.learnUserCount,
      ];
    })
    const initPercentData: [] = trainData.map((item: EchartTrainDataProps) => {
      return [
        item.provinceName,
        item.learnRatio,
      ];
    })

    setHospitalChartData(initHospitalData);
    setLearningChartData(initLearningData);
    setPercentOfPassData(initPercentData);
    setEchartData({
      hospitalData,
      userData,
      trainData,
    });
  }
  useEffect(() => {
    getOverAllOverViewData();
  }, []);
  const { hospitalData, userData, trainData } = echartData;
  const onSelectChangeHandle = (value: any) => {
    if (value === 'all') {
      value = undefined;
    }
    
    getOverAllOverViewData(value)
  }
  return (
    <div>
      <Form>
        <SubjectSelect
          label={false}
          showAll={true}
          styles={{ width: 160 }}
          onSelect={(value) => { onSelectChangeHandle(value) }}
        />
      </Form>
      <Divider />

      {/* <Histogram hospitalData={hospitalData} /> */}
      <BarChart
        id="hospital" 
        subtitle="单位：家"
        dimensions={["受援医院数", "支援医院数"]}
        sources={hospitalChartData} 
        exportPost={exportCountryHospitalDataManage}
        exportFileName="国家的支援和受援医院数量"
      />
      {/* <LineChart userData={userData} /> */}
      <BarChart 
        id="learning"
        subtitle="单位：人"
        dimensions={["注册人数", "学习人数"]}
        sources={learningChartData} 
        exportPost={exportCountryUserDataManage}
        exportFileName="国家的注册和学习人数"
      />
      {/* <TrainRatio trainData={trainData} /> */}
      <BarChart 
        id="percent"
        subtitle="单位：%"
        dimensions={["培训率"]}
        sources={percentOfPassData} 
        exportPost={exportCountryTrainDataManage}
        exportFileName="国家培训率"
      />
    </div>
  );
};

export default China;
